var DevOps = "DevOps";
var Gaming = "Jogos";
var Migration = "Migração";
var Other = "Outros";
var useCase = {
	"Use case": "Caso de uso",
	"AI & machine learning": "IA e machine learning",
	"Batch processing": "Processamento em lotes",
	"Big data, analytics, & business intelligence": "Big data, análise e business intelligence",
	"Business applications - Microsoft": "Aplicações empresariais – Microsoft",
	"Business applications - Oracle": "Aplicações empresariais – Oracle",
	"Business applications - Other": "Aplicações empresariais – Outros",
	"Business applications - SAP": "Aplicações empresariais – SAP",
	"Content delivery": "Distribuição de conteúdo",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet das Coisas",
	"Learning & certification": "Aprendizagem e certificação",
	"Media services": "Serviços de mídia",
	Migration: Migration,
	"Mobile applications": "Aplicativos para dispositivos móveis",
	Other: Other,
	"Storage & backup": "Armazenamento e backup",
	"Websites & web apps": "Sites e aplicações Web"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
